/**
 * CRM Events Async Thunks
 * All async actions for CRM events operations
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import * as crmEventsApi from '../api/crmEventsApi';

/**
 * Fetch all events (recent, calls, and missed calls)
 */
export const fetchAllEventsThunk = createAsyncThunk(
  'crmEvents/fetchAllEvents',
  async (_, { rejectWithValue }) => {
    try {
      const results = await Promise.allSettled([
        crmEventsApi.fetchRecentEvents(),
        crmEventsApi.fetchCallEvents(),
        crmEventsApi.fetchMissedCalls(),
      ]);

      return {
        recentMessages: results[0].status === 'fulfilled' ? (Array.isArray(results[0].value) ? results[0].value : []) : [],
        calls: results[1].status === 'fulfilled' ? (Array.isArray(results[1].value) ? results[1].value : []) : [],
        missedCalls: results[2].status === 'fulfilled' ? (Array.isArray(results[2].value) ? results[2].value : []) : [],
      };
    } catch (error) {
      console.error('Error fetching all events:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
